// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dayValue_orGZO {
  width: 100%;
}

.dayValue_orGZO > * {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/storeTraffic/hooks/useTrafficTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".dayValue {\n  width: 100%;\n}\n\n.dayValue > * {\n  flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dayValue": `dayValue_orGZO`
};
export default ___CSS_LOADER_EXPORT___;
